import { notification } from "antd";

export const openNotification = (
  message: string,
  description: string,
  type: "error" | "info" | "success" | "warning"
) => {
  notification.open({
    message,
    description,
    type,
  });
};
